export type PoolDataRequest = { poolId: string; preserveAum: true } | string

export const resolvePoolDataRequest = (request: PoolDataRequest) =>
  typeof request === 'string' ? { poolId: request, preserveAum: false } : request
